import orderInstance from '../instance'

const updateOrderCustomer = (orderId, data) => {
	return orderInstance.put(`/orders/${orderId}/customer` , data)
}

export default updateOrderCustomer
